import React, { ReactElement } from 'react';
import { Box, Text } from '@wix/design-system';
import s from './ChatMessage.module.scss';
import { Theme } from '../../types';
import cs from 'classnames';
import { LoadingAvatar } from './LoadingAvatar/LoadingAvatar';

interface ChatMessageProps {
  dataHook?: string;
  img: ReactElement;
  className: string;
  name: string;
  children: ReactElement;
  theme: Theme;
  isWidget?: boolean;
  isLoading?: boolean;
  isAssistant?: boolean;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({
  className,
  img,
  name,
  children,
  isWidget = false,
  isLoading,
  isAssistant,
}) => {
  return (
    <Box
      className={cs(className, s.messageBox, {
        [s.widget]: isWidget,
        [s.loading]: isLoading,
      })}
      direction="horizontal"
      scrollBehavior="smooth"
    >
      <Box className={s.nameBox}>
        <div className={s.imageWrapper}>{img}</div>
        <div
          className={cs(s.aiAvatarImageLoading, {
            [s.aiAvatarImageLoadingVisible]: isAssistant,
          })}
        >
          <LoadingAvatar />
        </div>
        <Text size="small" className={s.userName}>
          {name}
        </Text>
      </Box>

      <Box className={s.widgets} direction="vertical">
        {children}
      </Box>
    </Box>
  );
};
